/* global femcare */
femcare.form.validation = {
    /**
     * Initializes form validation for all forms with the 'validate-form' class.
     */
    init: function () {
        var $validatableForms = $('.validate-form');

        if ($validatableForms.length) {
            $validatableForms.each(
                $.proxy(function (index, form) {
                    this.initFormValidation($(form));
                }, this)
            );
        }
    },

    /**
     * Initializes form validation for a specific form.
     * @param {jQuery} $form - The jQuery form element to initialize validation for.
     */
    initFormValidation: function ($form) {
        var $validatableInputs = $form.find('[data-validate]');

        $validatableInputs.on('change', function () {
            $(this).validate();
        });

        $validatableInputs.filter('[data-match]').each(function (index, input) {
            var $input = $(input);
            var matchingInputId = $input.data('match');
            var $matchingInput = $('#' + matchingInputId);

            if ($matchingInput.length) {
                $matchingInput.on('change', function () {
                    $input.validate();
                });
            }
        });

        $form.on('submit', function (e) {
            if ($form.validateForm()) {
                femcare.tracking.gaTracking.formSubmit($form);
            } else {
                e.preventDefault();

                // Stop propagation to any additional onSubmit handlers
                e.stopImmediatePropagation();
            }
        });
    },
};
